import { useHistory } from "react-router-dom";

import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import {
  pushCreatedTableRowsIds,
  setNotificationsLoading,
  setNotificationsRefresh
} from "../../state/ducks";

import { notificationManagementErrors, routePaths, strCode } from "../../consts";
import { log, notificationManagementService, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";
import { useUploadNotificationImage } from "./useUploadNotificationImage";

export const parseErrorMessage = (err) => {
  const error = err?.response?.data?.error;
  let errorMessage = notificationManagementErrors[error] ?? error ?? err?.toString();

  if (error?.includes("INVALID_PARAMETER_PROVIDED")) {
    const invalidParameter = error.split(":")[1];
    errorMessage = t(strCode.INVALID_PARAMETER_PROVIDED, { invalidParameter });
  }

  return errorMessage;
};

export const useCreateNotification = () => {
  const loading = useSelector((store) => store.notifications?.loading);
  const refresh = useSelector((store) => store.notifications?.refresh);

  const history = useHistory();

  const { mutationCallback: uploadNotificationImage } = useUploadNotificationImage();

  const mutationCallback = async (notification, binaryImage, { isSystemNotification }) => {
    dispatch(setNotificationsLoading(true));

    try {
      let res;

      if (isSystemNotification) {
        res = await notificationManagementService.createSystemNotification(notification);
      } else {
        res = await notificationManagementService.createNotification(notification);
      }

      const imageUrl = res?.data?.data?.image;

      if (imageUrl && binaryImage) {
        await uploadNotificationImage(imageUrl, binaryImage);
      }

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.CREATE_NOTIFICATION_SUCCESS),
          message: t(strCode.CREATE_NOTIFICATION_SUCCESS_INFO, {
            name: notification?.notificationName
          })
        });

        dispatch(pushCreatedTableRowsIds([notification.notificationName]));

        dispatch(setNotificationsRefresh(true));
        dispatch(setNotificationsLoading(false));
        history.push(routePaths.NOTIFICATIONS);
      }
    } catch (err) {
      dispatch(setNotificationsLoading(false));
      log.error("useCreateNotification: Failed to create notification", err);

      notificationService.showError({
        title: t(strCode.CREATE_NOTIFICATION_ERROR),
        message: t(parseErrorMessage(err))
      });

      throw err;
    }
  };

  return { mutationCallback, loading, refresh };
};
